<template>
    <v-card :disabled="loading" variant="outlined" :loading="loading" rounded="0" class="" max-width="374">
        <v-card-item>
            <v-list-item class="w-100 text-left px-0">
                <template v-slot:prepend>
                    <v-avatar color="grey-darken-3" :image="`${$cloudFrontApi}${item.merchant.avatar}/AVATAR`"
                        class="clickable" @click="openProfile"></v-avatar>
                </template>

                <v-list-item-title class="clickable" @click="openProfile">{{ item.merchant.name }}</v-list-item-title>

                <v-list-item-subtitle>{{ item.merchant.tagline }}</v-list-item-subtitle>

                <template v-slot:append>
                    <div class="justify-self-end">
                        <v-tooltip activator="parent" location="end">{{$t('shop.favorite.tooltip.button')}}
                            <template v-slot:activator="{ props }">
                                <v-icon @click="likePost" v-bind="props" class="me-1" :color="liked ? 'primary' : ''"
                                    :icon="liked ? 'mdi-heart' : 'mdi-heart-outline'">
                                </v-icon>
                            </template>
                        </v-tooltip>
                    </div>
                </template>
            </v-list-item>
        </v-card-item>

        <v-responsive :aspect-ratio="1 / 1" content-class="d-flex align-items-center bg-gray">
            <v-img max-height="370" @click="overlay = true"
            :src="item?.images?.[0]?.id ? `${$cloudFrontApi}${item.images[0].id}/STREAM_MERCHANT` : null" contain class="clickable"></v-img>
        </v-responsive>
        <v-card-text>
            <h6>{{ item.headline }}</h6>
            <span>
                {{ item.text.length >= 120 ? item.text.slice(0, 120) + '...' : item.text }}
                <a class="ml-2" @click="() => triggerOpenCompanyPost(item)" v-if="item.text.length >= 120">mehr...</a>
            </span>

            <!-- <v-divider class="mx-4 mb-1"></v-divider> -->

            <div class="mt-3">
                <v-chip variant="flat" :color="label.color != '' ? label.color : '#e88be9'"
                    class="white--text colored-chip mr-2 my-1" v-for="label in item.labels" :key="label.id"
                    @click="() => triggerOpenDiscoverPopup(label)">{{
                        label.translations[selectedLanguage.toUpperCase()].value }}</v-chip>
            </div>

            <v-row class="mt-3" justify="between" v-if="item.minimumOrder != null">
                <v-col class="text-left">{{$t('fairling.form.prices.minimumOrder')}}</v-col>
                <v-col class="text-right">{{ $convertCentsToEuros(item.minimumOrder) }}</v-col>
            </v-row>
            <v-row class="mt-0 mb-1" justify="between" v-if="item.retailPrice != null">
                <v-col cols="auto" class="text-left">{{$t('fairling.profile.productHighlight.full.retailPrice')}}</v-col>
                <v-col  class="text-right">{{ $convertCentsToEuros(item.retailPrice) }}</v-col>
            </v-row>
            <v-row class="mt-0 mb-1" justify="between"
                v-if="item.retailPriceFrom != null || item.retailPriceTo != null">
                <v-col cols="auto" class="text-left">{{$t('fairling.profile.productHighlight.full.retailPrice')}}</v-col>
                <v-col class="text-right">{{$t('fairling.form.prices.from')}} {{ $convertCentsToEuros(item.retailPriceFrom) }} {{$t('fairling.form.prices.to')}} {{
                    $convertCentsToEuros(item.retailPriceTo) }}</v-col>
            </v-row>
            <v-row v-if="item?.additionalInformation">
                <v-btn variant="text" :ripple="false" elevation="0" color="primary"
                    @click="() => triggerOpenCompanyPost(item)">
                    <template v-slot:prepend>
                        <CustomIcon :size="18" :type="'none'" :iconName="`shippingIcon`" :fileType="'svg'"></CustomIcon>
                    </template>
                    {{$t('fairling.stream.additionalInformation')}}
                </v-btn>
            </v-row>
            <v-btn variant="flat" size="large" color="primary" rounded="lg" class="white--text mb-2 mt-3 w-100"
                @click="() => triggerOpenContactDialog(item.merchant)">{{$t('fairling.profile.contactRequest.getInTouch')}}</v-btn>
            <v-btn @click="openProfile" variant="outlined" size="large" rounded="lg" class="mb-2 w-100">{{$t('shop.merchantStream.checkProfile')}}
            </v-btn>
        </v-card-text>
    </v-card>


    <v-dialog v-model="overlay" content-class="justify-content-center d-flex align-items-center">
        <v-icon color="white" size="64" class="position-absolute right-0 top-0 clickable" style="z-index: 1000;"
            @click="overlay = false">mdi-close </v-icon>
        <v-carousel contain class=" overlay-carousel" height="700px">
            <v-carousel-item :aspect-ratio="1 / 1" class="" v-for="post in item.images" :key="post.id"
                :src="`${$cloudFrontApi}${post.id}/STREAM_MERCHANT`" contain></v-carousel-item>
            <template v-slot:next="{ props }">
                <v-icon v-bind="props" color="white" size="64">
                    mdi-chevron-right
                </v-icon>
            </template>
            <template v-slot:prev="{ props }">
                <v-icon v-bind="props" color="white" size="64">
                    mdi-chevron-left
                </v-icon>
            </template>
        </v-carousel>
        <!-- <v-responsive style="max-height: 100%; overflow: hidden;" class="w-100" max-height="100%" :aspect-ratio="1 / 1"
            content-class="d-flex align-items-center">
        </v-responsive> -->
    </v-dialog>
</template>

<script>
import { ref, watch, inject } from 'vue'
export default {
    setup(props) {
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const liked = ref(props.item.merchant.favoriteForCurrent)
        const overlay = ref(false);

        const openCompanyPost = inject('openCompanyPost')

        const openContactDialog = inject('openContactDialog')

        const triggerOpenContactDialog = (merchant) => {
            openContactDialog(merchant);
        }

        const openDiscoverPopup = inject('openDiscoverPopup');

        const triggerOpenDiscoverPopup = (label) => {
            openDiscoverPopup(label);
        }

        const triggerOpenCompanyPost = (post) => {
            openCompanyPost(post);
        }

        watch(() => props.item.merchant.favoriteForCurrent, (newItem) => {
            liked.value = newItem;
        });

        return {
            selectedLanguage,
            liked,
            overlay,
            triggerOpenCompanyPost,
            triggerOpenContactDialog,
            triggerOpenDiscoverPopup
        }
    },
    components: {
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            imageSrc: "https://picsum.photos/id/237/200/300", // You can replace with the actual image URL
        };
    },
    methods: {
        openProfile() {
            this.$router.push(`/fairling/${this.item.merchant.id}/${this.item.id}`)
            // this.$router.push(`/fairling/${this.item.merchant.id}/`);
        },
        likePost() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            const softToken = localStorage.getItem("softToken");
            // const obj = { uuid: this.item.id }
            this.$axios.post("shop/favorites", {
                uuid: this.item.merchant.id
            }, {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-SOFTTOKEN': softToken,
                    'X-Auth-USER': username
                },
            }
            ).then(this.postLiked)
                .catch()
        },
        postLiked(response) {
            this.liked = response.data.data;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none !important;
    cursor: pointer;
}

.v-chip {
    font-size: 14px;
    padding: 0 10px;
}

.card-container {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
    display: flex;
    align-items: center;
    background-color: #f5f5f5;
    padding: 16px;
}

.title {
    font-weight: bold;
    font-size: 18px;
}

.card-image {
    border-radius: 10px;
}

.card-subtitle {
    font-size: 14px;
    color: #6c757d;
    padding: 0 16px;
}

.card-actions {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
}

.chip {
    margin-right: 8px;
}
</style>

<style>
.v-overlay:has(.overlay-carousel) .v-overlay__scrim,
.v-overlay:has(.post-popup) .v-overlay__scrim {
    background: rgb(var(--v-theme-on-surface)) !important;
    opacity: var(--v-overlay-opacity, 0.8) !important;
}

.bg-gray {
    background: #f5f5f5;
}

.overlay-carousel .v-window__container {
    /*
    margin: 450px;
    */
}
</style>